import React, { Component } from "react";
import ReactDOM from "react-dom";
// import styled from "styled-components"
import { connect } from "../../utils";
import { RestApiProductList } from "../../../../../restClient";
import { List, ListProducts } from "./dealgroup";

class DealGroupView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widthElement: 0,
      values: [],
      productsContent: [],
    };
    this.getProductList();
  }
  componentDidMount() {
    // const { id, layoutState } = this.props
    // const { animation } = layoutState.getItemJS(id).props.values
    // if (animation && animation.show) {
    if (this.refs.dealGroupView) {
      const elementWidth = ReactDOM.findDOMNode(
        this.refs.dealGroupView
      ).getBoundingClientRect().width;
      this.setState({
        widthElement: elementWidth,
      });
    }
    // }
  }
  componentWillUnmount() {
    this.unmounting = true;
  }

  getProductList = () => {
    const { id, layoutState } = this.props;
    const { listProduct } = layoutState.getItemJS(id).props.values;
    let newValue = [];
    if (Array.isArray(listProduct)) {
      newValue = listProduct;
    }
    let params = newValue.join();
    const url = "/products?collections=" + params;
    RestApiProductList(url)
      .then((response) => {
        return response.json();
      })
      .then((items) => {
        // this is for check unmounting components
        if (this.unmounting) {
          return;
        }
        if (items && !items.messages) {
          let newItems = [];
          for (var i = 0; i < items.length; ++i) {
            for (var j = 0; j < items[i].products.length; ++j)
              newItems.push(items[i].products[j]);
          }
          this.setState({ productsContent: newItems });
          //this.setState({ productsContent: items });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  render() {
    const { id, layoutState } = this.props;
    // console.log(this.props, this.state.widthElement)
    const { containerPadding, typeContent } = layoutState.getItemJS(
      id
    ).props.values;
    const isDesktop = this.state.widthElement > 320;
    return (
      <div
        ref="dealGroupView"
        style={{
          boxSizing: "border-box",
          position: "relative",
          height: "auto",
          display: "flex",
          width: "100%",
          padding: containerPadding,
          flex: 1,
        }}
      >
        {typeContent === "custom" && (
          <List
            values={layoutState.getItemJS(id).props.values}
            isDesktop={isDesktop}
          />
        )}
        {typeContent === "collection" && (
          <ListProducts
            values={layoutState.getItemJS(id).props.values}
            isDesktop={isDesktop}
            list={this.state.productsContent}
          />
        )}
      </div>
    );
  }
}
export default connect("layoutState")(DealGroupView);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/DealGroupView.js